import React from 'react';

import s from './Avatar.module.css';

interface IAvatarProps {
  photoURL?: string;
}

const Avatar = ({ photoURL }: IAvatarProps) =>
  photoURL ? (
    <img src={photoURL} className={s.avatar} alt={'avatar'} />
  ) : (
    <div className={s.avatarEmpty} />
  );

export { Avatar };
